<template>
    <div class="fixed inset-0 flex items-center justify-center z-[100] px-4 sm:p-0" v-if="show">
        <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
            v-if="show"
        >
            <div class="fixed inset-0 bg-leonard-black-transparent transition-opacity" v-if="show"></div>
        </transition>

        <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
            <div class="bg-leonard-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline" v-if="show">
                <div class="mx-auto flex items-center justify-center h-12 w-12">
                    <span class="flex p-2 rounded-lg bg-yellow-100">
                        <!-- Heroicon name: exclamation-triangle -->
                        <svg class="h-6 w-6 text-yellow-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 10.5v3.75m-9.303 3.376C1.83 19.126 2.914 21 4.645 21h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 4.88c-.866-1.501-3.032-1.501-3.898 0L2.697 17.626zM12 17.25h.007v.008H12v-.008z" />
                        </svg>
                    </span>
                </div>
                <div class="mt-3 text-center sm:mt-5">
                    <h3 id="modal-headline">{{header}}</h3>
                    <p><small>{{body}}</small></p>
                </div>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                    <button
                        type="button"
                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-yellow-100 text-base leading-6 font-medium text-yellow-700 shadow-sm hover:bg-yellow-200 hover:text-yellow-600 focus:outline-none focus:border-yellow-500 focus:shadow-outline-orange transition ease-in-out duration-150 sm:text-sm sm:leading-5 sm:col-start-2"
                        @click.prevent="confirm"
                        v-text="confirmText ? confirmText : 'Confirm'"
                    ></button>
                    <button
                        type="button"
                        class="mt-3 inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-transparent text-base leading-6 font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:border-gray-400 focus:shadow-outline-orange transition ease-in-out duration-150 sm:text-sm sm:leading-5 sm:mt-0 sm:col-start-1"
                        @click.prevent="cancel"
                        v-text="cancelText ? cancelText : 'Cancel'"
                    ></button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['show', 'header', 'body', 'cancelText', 'confirmText'],

    methods: {
        confirm() {
            this.$emit('confirm');
        },

        cancel() {
            this.$emit('cancel');
        },
    },
}
</script>
